// extracted by mini-css-extract-plugin
export var card = "_s5-0";
export var details = "_s5-1";